module.exports = __webpack_public_path__ + "static/img/2-login.a545726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-login.png
// module id = 77Ug
// module chunks = 1